export default __webpack_public_path__ + "static/media/beer-club-md.c7088b1a.png";